<template>
  <div>
    <small>{{ contact.first_name }} - {{ contact.last_name }}</small><br >
    <a v-if="$root.canManage()" :href="`mailto:${contact.email}`">{{ contact.email }}</a>
  </div>
</template>

<script>
  export default {
    name: 'ContactEntityComponent',
    props: {
      contact: {
        type: Object,
        default() {
          return {};
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ContactEntity.vue